import db from '../../db';
import { getCurrentDate } from '../../time'
import {
    LOAD_IMPUTATIONS_BY_DAY,
    ADD_IMPUTATION,
    UPDATE_IMPUTATION,
    DELETE_IMPUTATION,
    ERROR,
    IS_LOADING,
    SET_ALL_IMPUTATIONS,
    SET_CURRENT_OR_LAST_IMPUTATION,
    SET_INTERVENTIONS_FOR_IMPUTATIONS,
    DEFAULT_CHECK_PERIOD_IN_MINUTES
} from "./imputationsConstants"
import { throwErrorMessage } from '../../lib/error_helper';
import { adaptImputationForMyOpen, deleteImputations, deleteImputationsInDb } from './imputationsEditionActions';
import moment from 'moment'
import { fetchWithTimeout } from '../../lib/fetch_wrapper';

export function addImputationSuccess(imputation) {
    return {
        type: ADD_IMPUTATION,
        newImputation: imputation,
    };
}

export function setCurrentOrLastImputationAction(currentOrLastImputation) {
    return {
        currentOrLastImputation,
        type: SET_CURRENT_OR_LAST_IMPUTATION,
    }
}

export function setAllImputationsAction(allImputations) {
    return {
        type: SET_ALL_IMPUTATIONS,
        imputations: allImputations,
    }
}

export function setAllInterventionsAction(interventions) {
    return {
        type: SET_INTERVENTIONS_FOR_IMPUTATIONS,
        interventions,
    }
}

export function updateImputationSuccess(imputation) {
    return {
        type: UPDATE_IMPUTATION,
        imputation: imputation
    };
}

export function imputationIsLoadingAction(bool) {
    return {
        type: IS_LOADING,
        isLoading: bool
    };
}

export function deleteImputationSuccess(id) {
    return {
        type: DELETE_IMPUTATION,
        idImputation: id
    };
}

export async function getImputationsByDay(day_id) {
    return await db.transaction("r?", db.Imputation, async () => {
        return await db.Imputation.where('day_id').equals(day_id).toArray(async (data) => {
            data = data.sort((a, b) => {
                return (a.date_end === null ? (b.date_end === null ? (a.date_start < b.date_start ? 1 : -1) : -1) : (b.date_end === null ? 2 : (a.date_end < b.date_end ? 1 : (a.date_start < b.date_start ? 1 : -1))));
            });//Imputations triées par ordre de fin croissant
            return data;
        }).catch((e) => {
            throw e;
        })
    }).catch((e) => {
        console.error("Erreur lors de la récupération des imputations d'une journée")
        throw e;
    })
}

export function loadImputationsByDay(day_id) {
    return async (dispatch) => {
        await db.transaction("r?", db.Imputation, db.Day, async () => {
            await db.Imputation.where('day_id').equals(day_id).toArray((data) => {
                data = data.sort((a, b) => {
                    return (a.date_end === null ? (b.date_end === null ? (a.date_start < b.date_start ? 1 : -1) : -1) : (b.date_end === null ? 2 : (a.date_end < b.date_end ? 1 : (a.date_start < b.date_start ? 1 : -1))));
                });//Imputations triées par ordre de fin croissant

                dispatch({
                    type: LOAD_IMPUTATIONS_BY_DAY,
                    imputations: data,
                })
            }).catch((e) => {
                throw e;
            });
        }).catch((e) => {
            console.error("Erreur : imputationsActions - loadImputationsByDay", e);
            throw e;
        });
    }
}

export function getImputationToDelete(user_id, inDb) {
    return (dispatch) => {
        return db.transaction("r?", db.Day, db.Imputation, () => {
            db.Day.where({ user_id: user_id }).toArray((coll) => {
                let day = undefined;
                for (let i = 0; i < coll.length; i++) {
                    if (coll[i].active) {
                        day = coll[i];
                    }
                }
                if (day !== undefined && !day.validation) {
                    db.Imputation.where({ day_id: day.id }).toArray((coll) => {
                        if (inDb) {
                            dispatch(deleteImputationsInDb(coll));
                        } else {
                            dispatch(deleteImputations(coll));
                        }
                    }).catch((err) => {
                        console.error("Erreur : imputationsActions - getImputationToDelete")
                        dispatch(throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message: "Récupération des imputations du jour " + day.id,
                        }));
                        dispatch({ type: ERROR, info: ("Récupération des imputations du jour " + day.id), error: err });
                    });
                }
            }).catch((err) => {
                console.error("Erreur : imputationsActions - getImputationToDelete")
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Récupération des imputations à supprimer impossible ",
                }));
                dispatch({ type: ERROR, info: ("Erreur lors de la récupération du jour actif de l'utilisateur " + user_id), error: err });
            });
        }).catch((err) => {
            console.error("Erreur : imputationsActions - getImputationToDelete")
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Récupération des imputations à supprimer impossible ",
            }));
            dispatch({ type: ERROR, info: ("Erreur lors de la récupération du jour actif de l'utilisateur " + user_id), error: err });
        });
    }
}

export function getAllImputations() {
    return (dispatch) => {
        return db.Imputation.toArray((data) => data).then((imputations) => {
            dispatch(setAllImputationsAction(imputations));
        });
    }
}

export async function getImputationsById(id) {
    return await db.Imputation.where('id').equals(id).first(async (data) => {
        return data;
    }).catch((e) => {
        console.error("Erreur : imputationsActions - getImputationsById");
        throw e;
    });
}

export async function getImputationInProgressByDay(day_id) {
    let in_progress = [];
    let data = await getImputationsByDay(day_id);

    if (!data)
        return in_progress;

    for (let i = 0; i < data.length; i++) {
        if (data[i].in_progress === true) {
            in_progress.push(data[i]);
        }
    }

    return in_progress;
}

export function getImputationsInProgress() {
    return new Promise((resolve, reject) => {
        return db.transaction("r?", db.Imputation, db.Day, db.User, () => {
            db.Imputation.toArray((data) => data).then((imputations) => {
                let inProgressImputations = imputations.filter((i) => i.in_progress)
                return resolve(inProgressImputations);
            }).catch((err) => {
                return reject(err);
            })
        }).catch((err) => {
            return reject(err)
        })
    })
}

export async function gotActivityInProgress(imputation) {
    return await db.transaction("r?", db.Imputation, db.Day, db.User, async () => {
        let data = await getImputationsBetweenImputation(imputation);
        if (data.filter((currentImputation) => {
            return currentImputation.in_progress
        }).length > 0) {
            return true;
        }

        return false;
    });
}

export async function getImputationsBetweenImputation(imputation) {
    let data = await getImputationsByDay(imputation.day_id);
    let inBetween = [];
    let time = getCurrentDate(true);
    let start = imputation.date_start;
    let end = (imputation.in_progress ? time : imputation.date_end);
    for (let i = 0; i < data.length; i++) {
        let item_start = data[i].date_start;
        let item_end = data[i].date_end;

        if (data[i].in_progress && item_start < start) {
            inBetween.push(data[i]);
            continue;
        }

        if (data[i].in_progress && (imputation.in_progress || imputation.activity.endOfDay)) {
            inBetween.push(data[i]);
            continue;
        }

        if (imputation.id !== data[i].id && (item_start < end && start < item_end)) {
            inBetween.push(data[i]);
        }
    }

    return inBetween;
}

export function imputationIsLoading(bool) {
    return (dispatch) => {
        dispatch(imputationIsLoadingAction(bool));
    }
}

export function getCurrentOrLastImputation() {
    return (dispatch) => {
        let imputation = null;

        db.transaction("rw?", db.Imputation, () => {
            db.Imputation.toArray().then((imputations) => {

                if (imputations.length <= 0) {
                    dispatch(setCurrentOrLastImputationAction(imputation))
                }

                imputation = imputations.find(i => i.in_progress)

                if (!imputation) {
                    imputation = imputations.sort((a, b) => new Date(a.date_start) - new Date(b.date_start))[imputations.length - 1]
                }

                dispatch(setCurrentOrLastImputationAction(imputation))
            })
        })
    }
}

export function initPeriodicCheckOfTTE(loggedEmployee, user) {
    return (dispatch) => {
        dispatch(checkIfMaxTTEExceeded(loggedEmployee, user))
        setInterval(() => {
            dispatch(checkIfMaxTTEExceeded(loggedEmployee, user))
        }, DEFAULT_CHECK_PERIOD_IN_MINUTES * 60000)
    }
}

export function checkIfMaxTTEExceeded(loggedEmployee, user) {
    return (dispatch) => {

        db.Imputation.filter((currentImputation) => {
            let imputation = adaptImputationForMyOpen(currentImputation);
            return imputation.date_start.isSame(moment(), 'day') || imputation.in_progress
        }).toArray().then((imputationsOfCurrentDay) => {
            let currentBaseTTE = 0;

            if (imputationsOfCurrentDay.length <= 0)
                return

            imputationsOfCurrentDay.forEach(i => {
                let imputation = adaptImputationForMyOpen(i);
                var duration = 0
                let start = imputation.date_start;

                if (!imputation.date_start.isSame(moment(), 'day') && imputation.in_progress)
                    start = moment().startOf('day')

                if (!imputation.activity.is_working_activity && !imputation.activity.driving)
                    return

                if (i.date_end)
                    duration = imputation.date_end.diff(start, 'hours', true);
                else
                    duration = moment().diff(start, 'hours', true);

                currentBaseTTE += duration;
            })

            let theoreticalTTE = currentBaseTTE * loggedEmployee.working_time_ratio / 100

            if (theoreticalTTE > loggedEmployee.max_daily_working_time) {
                dispatch(treatMaxTTEPerDayExceeded(null, loggedEmployee, theoreticalTTE, user))
            } else if (theoreticalTTE > (loggedEmployee.max_daily_working_time * loggedEmployee.daily_alert_threshold / 100)) {
                dispatch(treatMaxTTEPerDayExceeded(loggedEmployee.daily_alert_threshold, loggedEmployee, theoreticalTTE, user))
            }
        })
    }
}

export function getServerTimestamp(user, discreet) {
  return async (dispatch) => {
    try {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const response = await fetchWithTimeout('/api/v1/imputations/get_server_timestamp/', {
            method: 'POST',
            headers: headers,
            timeout: 60000,
            body: JSON.stringify({ userId: user.id }),
        });

        if (!response.ok) throw Error(response.statusText);

        const serverTimestamp = await response.json();

        // conversion et validation
        const tsSeconds = Number(serverTimestamp);
        if (Number.isNaN(tsSeconds)) throw new Error("Invalid server timestamp");

        var date = new Date(tsSeconds * 1000);
        return date; 
    } catch (err) {
        console.error("Erreur : imputationsActions - getServerTimestamp", err);

        if (!discreet) {
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la récupération de l'heure serveur",
            }));
        }
        throw err;
    }
  }
}


export function getTimeParameters(user, discreet) {
  return async (dispatch) => {
    try {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const response = await fetchWithTimeout('/api/v1/imputations/get_config_parameters/', {
            method: 'POST',
            headers: headers,
            timeout: 60000,
            body: JSON.stringify({ user: user }),
        });

        if (!response.ok) throw Error(response.statusText);

        return await response.json();
    } catch (err) {
        console.error("Erreur : imputationsActions - getTimeParameters", err);

        if (!discreet) {
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la récupération des paramètres de temps",
            }));
        }
        throw err;
    }
  }
}

function treatMaxTTEPerDayExceeded(threshold, loggedEmployee, currentTTE, user) {
    return (dispatch) => {
        let message = "Votre temps de travail effectif jour dépasse le seuil légal. Veuillez contacter votre manager pour mettre en place un plan d'action";

        const workingTimeLimitTag = "WorkingTimeLimit";

        if (threshold)
            message = "Vous avez atteint " + threshold + "% de votre temps de travail effectif jour. Veuillez contacter votre manager pour l’organisation de votre planning";


        dispatch(throwErrorMessage({
            title: message,
            dismissible: "button",
            autoDismiss: 0,
            uid: workingTimeLimitTag
        }))

        if (!hasAlreadyBeenNotifyToday(threshold)) {
            localStorage.setItem(threshold ? 'ThresholdWorkingTimeLimitLastNotificationDate' : 'WorkingTimeLimitLastNotificationDate', moment());
            navigator.serviceWorker.ready.then(function (registration) {
                registration.showNotification("Dépassement de temps de travail effectif", {
                    body: message,
                    dir: "ltr",
                    tag: workingTimeLimitTag,
                    icon: "/images/favicon/favicon-tr.png",
                    badge: "/images/favicon/favicon-tr.png",
                })

            });

            dispatch(preventManagerForTTEExceeded(loggedEmployee, currentTTE, user, threshold));
        }
    }
}

function preventManagerForTTEExceeded(loggedEmployee, currentTTE, user, threshold) {
    return (dispatch) => {
        let working_time_alert_threshold = (Math.round(currentTTE / loggedEmployee.max_daily_working_time * 100)) + "%";

        const headers = new Headers({ 'Content-Type': 'application/json' });
        const body = JSON.stringify({
            employeeId: user.emp_id,
            working_time_alert_day: moment().format("DD/MM/YYYY"),
            userId: user.id,
            working_time_alert_threshold,
            threshold
        });

        fetchWithTimeout('/api/v1/imputations/prevent_manager_for_tte_exceeded/', {
            method: 'POST',
            headers: headers,
            body: body,
        }).then((response) => {
            if (!response.ok)
                throw Error(response.statusText);
        })
            .catch((err) => {
                console.error("Erreur : imputationsActions - preventManagerForTTEExceeded", err)
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de l'envoi du mail au manager",
                }))
            });
    }
}

function hasAlreadyBeenNotifyToday(threshold) {
    let workingTimeLimitLastNotificationDate = localStorage.getItem(threshold ? 'ThresholdWorkingTimeLimitLastNotificationDate' : 'WorkingTimeLimitLastNotificationDate');
    return moment(workingTimeLimitLastNotificationDate).isSame(moment(), 'day')
}
